<template>
  <section
    data-aos="fade"
    id="features"
    class="bg-[#f9f5f0] pt-24 relative sm:pt-32 lg:py-32"
  >
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -top-4 w-full"
      height="32"
    />
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -bottom-4 -scale-100 w-full"
      width="375"
    />
    <div data-aos="fade-up" class="mx-auto max-w-7xl px-6 lg:px-8">
      <div
        class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-5"
      >
        <div class="col-span-2 relative pb-4">
          <h2 class="text-base/7 font-semibold text-purple-600 relative">
            <img
              :src="Arrow"
              alt="Arrow drawing squiggle"
              class="absolute h-16 w-auto right-0 bottom-0 -scale-x-100 sm:right-auto sm:-left-32 sm:scale-x-100"
              height="64"
              width="80"
            />
            Everything you need
          </h2>
          <p
            class="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl"
          >
            Days run
            <span class="relative inline-block">
              <img
                :src="PurpleHeart"
                alt="Purple heart drawing"
                class="hidden sm:block absolute -top-4 w-4 left-2 -scale-x-100"
                height="16"
                width="16"
              />
              <img
                :src="GreenHeart"
                alt="Green heart drawing"
                class="hidden sm:block absolute -top-8 w-8 right-0"
                height="32"
                width="32"
              />
              smoother
            </span>
            with our app
          </p>
          <p class="mt-6 text-base/7 text-gray-600">
            Our app is designed to support you both inside and outside of the
            classroom – making your day smoother, more rewarding and more
            connected.
          </p>
        </div>
        <dl
          class="col-span-3 grid grid-cols-1 gap-x-8 gap-y-10 text-base/7 text-gray-600 sm:grid-cols-2 lg:gap-y-12"
        >
          <div v-for="item in list" :key="item.id" class="relative pl-9">
            <dt class="font-semibold text-gray-900">
              <i class="text-purple-600 me-2" :class="item.icon"></i>
              {{ item.title }}
            </dt>
            <dd class="mt-2">
              {{ item.body }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <img
      data-aos="fade-left"
      :src="Mockup"
      alt="Mobile prototype mockup"
      class="relative h-96 mt-12 -bottom-4 ms-auto w-auto lg:mt-0 lg:absolute lg:left-1/5"
      height="384"
      width="375"
      loading="lazy"
    />
  </section>
</template>
<script setup lang="ts">
import BeigeBorder from "/graphics/expert-top.svg";
import GreenHeart from "/graphics/green/heart.svg";
import PurpleHeart from "/graphics/purple/heart.svg";
import Arrow from "/graphics/purple/arrow-2.svg";
import Mockup from "/mockups/14.webp";

const list = [
  {
    id: 1,
    title: "Motivate and build confidence",
    body: "Recognise effort, celebrate progress and share it with home. Award badges and points that highlight both academic achievement and personal development.",
    icon: "fas fa-stars",
  },
  {
    id: 2,
    title: "Capture classroom moments in real-life",
    body: "Easily document and share key observations with parents as they happen. From small wins to big breakthroughs, keep families in the loop and build stronger home-school connections without adding to your workload.",
    icon: "fas fa-camera",
  },
  {
    id: 4,
    title: "Take registers",
    body: "Juniper MIS customers can take attendance quickly from your tablet and sync it straight to your Juniper MIS. It’s one less admin task to worry about.",
    icon: "fas fa-clipboard",
  },
  {
    id: 5,
    title: "Stay in the loop",
    body: "Access school news and newsletters – anytime, from anywhere.",
    icon: "fas fa-megaphone",
  },
  {
    id: 6,
    title: "Make notes and prioritise them",
    body: "Draft your thoughts, save ideas and track plans with built-in private notes.",
    icon: "fas fa-file-signature",
  },
  {
    id: 7,
    title: "Track progress and praise",
    body: "View badge history, points awarded and parent feedback – all in one place.",
    icon: "fas fa-heart",
  },
];
</script>
